import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { borderStyle, borderStyleOptions } from '@adalo/constants'

import { updateObject } from '../../../ducks/editor/objects'
import { getAppBranding } from '../../../ducks/apps'
import SingleNumberControl from './SingleNumberControl'
import SelectControl from './SelectControl'
import ColorDropdown from './ColorDropdown'
import CommonInspectRow from './GenericRow'

class BorderControl extends Component {
  static propTypes = {
    branding: PropTypes.shape({}).isRequired,
    object: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    updateObject: PropTypes.func.isRequired,
  }

  state = {
    savedStyle: borderStyle.SOLID,
  }

  handleChange = values => {
    const { object, updateObject } = this.props
    updateObject(object.id, values)
  }

  handleToggle = isEnabled => {
    const { object } = this.props

    if (isEnabled) {
      const { savedStyle = borderStyle.SOLID } = this.state

      this.handleChange({
        borderStyle: savedStyle,
      })
    } else {
      this.setState({ savedStyle: object.borderStyle || borderStyle.SOLID })
      this.handleChange({ borderStyle: borderStyle.NONE })
    }
  }

  render() {
    const { branding, object } = this.props
    const { savedStyle } = this.state
    const isEnabled = object.borderStyle !== borderStyle.NONE

    return (
      <CommonInspectRow
        title="Border"
        className="border-control"
        togglable
        toggled={isEnabled}
        onToggle={this.handleToggle}
      >
        <ColorDropdown
          branding={branding}
          value={object.borderColor}
          name="borderColor"
          disabled={!isEnabled}
          onChange={this.handleChange}
        />
        <div className="border-control-split">
          <SingleNumberControl
            gray
            name="borderWidth"
            value={object.borderWidth}
            disabled={!isEnabled}
            onChange={this.handleChange}
          />
          <SelectControl
            name="borderStyle"
            small={false}
            defaultValue={borderStyle.NONE}
            value={isEnabled ? object.borderStyle : savedStyle}
            disabled={!isEnabled}
            onChange={this.handleChange}
            options={borderStyleOptions}
          />
        </div>
      </CommonInspectRow>
    )
  }
}

const mapStateToProps = (state, { appId }) => ({
  branding: getAppBranding(state, appId),
})

export default connect(mapStateToProps, { updateObject })(BorderControl)
